import { Box, Divider, Title } from '@mantine/core'
import { WidgetCard } from '@/components/ui/WidgetCard'
import { CardHeader } from '@/components/ui/CardHeader'
import { CardFooter } from '@/components/ui/CardFooter'

interface CartaoDeLeituraProps {
  /** O nome do cartão ("Chamado #9"), o "Read Mail" do modelo. */
  rotulo: string
  /** O assunto, em destaque no corpo, acima do remetente. */
  titulo: string
  /** Os botões ← ↑ ↓ à direita do cabeçalho. */
  navegacao: React.ReactNode
  remetente: React.ReactNode
  /** Descrição, detalhes e anexos. */
  children: React.ReactNode
  /** A faixa Próximo passo; `null` quando não há ação para quem olha. */
  proximoPasso?: React.ReactNode
  rodape: React.ReactNode
}

/**
 * O cartão de leitura do chamado, no modelo "Read Message" do Mailbox (spec 2026-10-21 §3):
 * cabeçalho com o nome do cartão e a navegação, o assunto, o remetente, o corpo, a faixa Próximo
 * passo e o rodapé.
 * Só disposição: quem decide o conteúdo de cada parte é a página.
 */
export function CartaoDeLeitura({
  rotulo, titulo, navegacao, remetente, children, proximoPasso, rodape,
}: CartaoDeLeituraProps) {
  return (
    <WidgetCard p={0} data-testid="cartao-de-leitura">
      <CardHeader title={rotulo} extra={navegacao} />
      <Box p="md">
        <Title order={4} mb="md" c="var(--ai-text-primary)" style={{ overflowWrap: 'anywhere' }}>{titulo}</Title>
        {remetente}
        <Divider my="md" color="var(--ai-border-light)" />
        {children}
      </Box>
      {proximoPasso}
      <CardFooter>{rodape}</CardFooter>
    </WidgetCard>
  )
}
